export function getDisabledTooltipKey({
  emptyAccountField,
  emptyRecipients,
  mass,
}) {
  if (emptyRecipients) {
    return 'Emails.EmptyToFieldTooltipVariablesBtnKey'
  }

  if (emptyAccountField) {
    return 'Emails.EmptyFromFieldTooltipVariablesBtnKey'
  }

  if (!mass) {
    return 'Emails.MassMailingNotSelectedTooltipVariablesBtnKey'
  }

  return 'Emails.EmptyTemplateTooltipVariablesBtnKey'
}
